var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "k-offer-card" }, [
    _c(
      "div",
      { staticClass: "image" },
      [
        _vm.offer.partner.is_exclusive
          ? _c("k-icon", {
              staticClass: "exclusive",
              attrs: { icon: "favorite-filled" }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("img", {
          staticClass: "logo",
          attrs: { src: _vm.offer.partner.logo, alt: _vm.offer.partner.name }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "info" },
        [
          _c("h2", { staticClass: "title" }, [
            _vm._v("\n        " + _vm._s(_vm.offer.title) + "\n      ")
          ]),
          _vm._v(" "),
          _vm.offer.category
            ? _c("div", { staticClass: "category" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.offer.category) +
                    " " +
                    _vm._s(_vm.distance) +
                    "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("like", {
            staticClass: "-k-offer-likes",
            attrs: { liked: _vm.offer.is_favorited, likes: _vm.offer.likes },
            on: {
              like: function($event) {
                return _vm.$emit("like")
              },
              unlike: function($event) {
                return _vm.$emit("unlike")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tags" },
        [
          _vm.offer.value
            ? _c(
                "k-tag",
                {
                  staticClass: "k-offer-card-tag",
                  attrs: { color: "primary-2" }
                },
                [_vm._v("\n        " + _vm._s(_vm.off) + "\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.offer.eventData.is_cashback
            ? _c("k-tag", { staticClass: "k-offer-card-tag" }, [
                _vm._v("\n        " + _vm._s(_vm.cashback) + "\n      ")
              ])
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c351f92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c351f92","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/kaledo-components/src/components/KOfferCard.vue
// module id = 2064
// module chunks = 1610